<template>
  <VLayout :title="$t('search.search')" :subtitle="$t('search.results') + ' ' + subtitle">
    <div>
      <vue-element-loading :active="$checkingAuthState" />
    </div>
    <ProductsViewer
      v-if="!$checkingAuthState"
      :source="dataSource"
      :payload="payload"
      filterOrderBy="none"
    />
  </VLayout>
</template>


<script>
import VLayout from "@/layouts/Default";
import ProductsViewer from "@/components/ProductsViewer";

export default {
  components: {
    VLayout,
    ProductsViewer,
  },
  computed: {
    query: function() {
      return this.$route.query.query;
    },
    letter: function() {
      return this.$route.query.letter;
    },
    subtitle: function() {
      if (this.query) {
        return this.query;
      }
      if (this.letter) {
        return this.letter;
      }
      return "";
    },
    dataSource: function() {
      return "drugs/REQUEST_PHDRUGS";
    },
    payload: function() {
      return {
        letter: this.letter,
        search: this.query,
      };
    },
  },
  fallbackI18n: {
    messages: {
      und: {
        search: {
          search: "Search",
          results: "Results by",
        },
      },
    },
  },
};
</script>


<style>
</style>
